interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <div className="mt-10 flex items-center justify-center gap-1.5">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 px-3 text-xs text-foreground-600 transition-colors whitespace-nowrap enabled:hover:border-primary-300 enabled:hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line text-base" aria-hidden="true" />
        上一页
      </button>
      {Array.from({ length: totalPages }, (_, index) => index + 1).map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          aria-current={item === page}
          className={`h-9 w-9 rounded-md font-label text-xs transition-colors ${
            item === page
              ? "bg-primary-900 text-background-50"
              : "border border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-700"
          }`}
        >
          {item}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 px-3 text-xs text-foreground-600 transition-colors whitespace-nowrap enabled:hover:border-primary-300 enabled:hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line text-base" aria-hidden="true" />
      </button>
    </div>
  );
}